<template>
    <div>
        <v-container fluid grid-list-xl class="assessment-start-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device :title="text('api.pro.startAssessmentPage.title')"
                                               :shortcutNav="this.shortcutNav"
                                               @setIsKeyboardNav="setIsKeyboardNav"
                                               ref="headerBarMedicalDeviceRef"
                    >

                    </header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div class="scrolling-content"
                 ref="startAssessmentScrollingContentRef">

                <v-layout row wrap class="">
                    <v-flex lg4 md6 xs12 v-if="mustShowPatientPanel" >
                        <patient-profile ref="patientProfileRef"
                                         :class="{'panel-highlighted': (shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'PATIENT_INFO')}"
                                         @click.native="onPanelClick('PATIENT_INFO')"
                                         :shortcutNav="this.shortcutNav">
                        </patient-profile>
                    </v-flex>
                    <v-flex lg4 md6 xs12>
                        <start-questions :ref="'questionsPanel_' + 'START_QUESTIONS'"
                                         :class="{'panel-highlighted': (shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'START_QUESTIONS')}"
                                         @click.native="onPanelClick('START_QUESTIONS')"
                                         @emitChangeAnswer="onChangeAnswer"
                                         @emitQuestionClick="onQuestionClick"
                                         :shortcutNav="this.shortcutNav">
                        </start-questions>
                    </v-flex>
                    <v-flex lg4 md6 xs12>
                        <general-questions :ref="'questionsPanel_' + 'GENERAL_QUESTIONS'"
                                           :class="{'panel-highlighted': (shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'GENERAL_QUESTIONS')}"
                                           @click.native="onPanelClick('GENERAL_QUESTIONS')"
                                           @emitChangeAnswer="onChangeAnswer"
                                           @emitQuestionClick="onQuestionClick"
                                           :shortcutNav="this.shortcutNav">
                        </general-questions>
                    </v-flex>
                </v-layout>
            </div>
        </v-container>

        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex xs12 text-xs-center>
                    <v-btn @click="gotoScoringPage()"
                           id="btnFinishAssessment"
                           class="footer-btn goToScoring"
                           :class="{'is-semi-target': isSemiTarget}"
                           flat
                    >
                        {{text('api.button.finish')}}
                        <finish-icon />
                    </v-btn>

                    <div class="footer-right-btns">
                        <v-btn @click="goToNextPage"
                               :disabled="!isFooterNextBtnEnabled && !isSemiTarget"
                               id="btnGoToNextAssessmentPage"
                               class="footer-btn footer-btn-next color-on-primary-text"
                               :class="{'is-semi-target': isSemiTarget}"
                               color="primary">
                            {{ text('api.button.next') }}
                            <arrow-next-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </v-btn>
                    </div>


                </v-flex>
            </v-layout>
        </v-footer>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
        <general-questions-popup></general-questions-popup>

        <div v-if="getMustShowVitalParamsForm" class="vital-params-form-overlay overlay overlay--active"></div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import HeaderBar from "../shared/HeaderBar";
import TopBar from '../../../common/components/shared/TopBar';
import PatientProfile from "./PatientProfile";
import StartQuestions from "./StartQuestions";
import GeneralQuestions from "./GeneralQuestions";
import {mapActions, mapGetters} from 'vuex';
import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
import QuestionListBlock from "../../../common/components/shared/QuestionListBlock";
import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
import HeaderBarMedicalDevice from "../shared/HeaderBarMedicalDevice";
import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
import GeneralQuestionsPopup from '../../../common/components/shared/GenQAreNotAllAnswPopup';
import FinishIcon from "../../../common/components/svg/shared/finishIcon";
import ArrowNextIcon from "../../../common/components/svg/shared/arrowNextIcon";
import {forEach} from "axios/lib/utils";

const AS_PANEL = {
        PATIENT_INFO: "PATIENT_INFO",
        START_QUESTIONS: "START_QUESTIONS",
        GENERAL_QUESTIONS: "GENERAL_QUESTIONS",
        VITAL_PARAMETERS: "VITAL_PARAMETERS"
    };

    const PATIENT_INFO_FIELD = {
        FIELD_PID: "FIELD_PID",
        FIELD_COMMENT: "FIELD_COMMENT"
    };

    const AS_PANELS = [
        AS_PANEL.PATIENT_INFO,
        AS_PANEL.START_QUESTIONS,
        AS_PANEL.GENERAL_QUESTIONS
    ];

    const AS_PANELS_NO_PAT_PROFILE = [
        AS_PANEL.START_QUESTIONS,
        AS_PANEL.GENERAL_QUESTIONS
    ];

    const PATIENT_FIELD_LIST = [
        PATIENT_INFO_FIELD.FIELD_PID,
        PATIENT_INFO_FIELD.FIELD_COMMENT
    ];


    export default {
        name: 'AssessmentStartPage',

        components: {
            ArrowNextIcon,
            FinishIcon,
            GeneralQuestions,
            StartQuestions,
            PatientProfile,
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            QuestionListBlock,
            AcceptCookie,
            HeaderBarMedicalDevice,
            DetectBrowserCookie,
            GeneralQuestionsPopup
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || (this.$route.query.referral !== "testsTreeNode" && this.$route.query.referral !== "autoLogin")) {
                this.$store.commit('AssessmentStartStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
                this.$store.commit('ScoringStore/setIsAssessmentSealed', false);
            }
        },

        created () {
            // If the url has param ?referral=testsTreeNode, that means that we are coming from tests tree,
            // so data for this page should be already loaded and must be kept and used.
            // Otherwise, (re)load data now.
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsTreeNode") {
                this.$router.replace({'referral': null});
            }
            else if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsProductList") {
                this.$store.dispatch("AssessmentStartStore/loadAssessmentTestData");
                this.$router.replace({'referral': null});
            }
            else if ( typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "autoLogin"){
                // remove the query parameter
                this.$router.replace({'referral': null});

                // load the assessment start data.
                this.$store.dispatch("AssessmentStartStore/loadAssessmentStartData")
                    .then((response) => {

                        // this will get the pid if it was provided
                        this.$store.commit("AssessmentStartStore/setPatientProfileData", this.$store.getters['SubmittedValuesStore/getPatientProfileData']);

                        // now that all the values are set we can clean the submittedValuesStore.
                        this.$store.commit('SubmittedValuesStore/resetStore');

                    })
                    .catch((error) => {
                        // 251 = UNKNOWN_PRODUCT_CODE, 204 = ASSESSMENT_TOKEN_INVALID
                        if (error.serverResponse != null && error.serverResponse.data != null) {
                            if (error.serverResponse.data.returnCode === 251){
                                console.log("invalid production code");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages', 'Unauthorised Access To Product');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    console.log("has been logged out");
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'userNotRegistratedForProduct');
                                    this.$router.push({path: '/auto-login'});
                                });
                            }
                            else if (error.serverResponse.data.returnCode === 204 ) {
                                console.log("The assessmenttoken already exists");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages','AssessmentToken already exists');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'assessmentTokenExists');
                                    console.log("has been logged out");
                                    this.$router.push({ path: '/auto-login'});
                                });
                            }
                            else if (error.serverResponse.data.returnCode === 275) {
                                console.log("The assessmenttoken format invalid");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages','AssessmentToken format invalid');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    console.log("has been logged out");
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'assessmentTokenFormatInvalid');
                                    this.$router.push({ path: '/auto-login'});
                                });
                            }
                            else if (error.serverResponse.data.returnCode === 116 ) {
                                console.log("Unauthorised Access To Product");
                                this.$store.commit('SubmittedValuesStore/setErrorMessages','Unauthorised Access To Product');
                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    console.log("has been logged out");
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'unauthorisedAccessToProduct');
                                    this.$router.push({path: '/auto-login'});
                                });
                            }
                        }
                        // 263 == INVALID PARAMETER NAME OR VALUE
                        else if (error.data.returnCode === 263 && error.data.paramMedValidation != null) {

                            if (error.data.paramMedValidation.generalValidationError != null) {
                                const generalValidationError = error.data.paramMedValidation.generalValidationError;
                                if (generalValidationError.validationError != null && generalValidationError.validationErrorParam != null) {
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', generalValidationError.validationError);
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', generalValidationError.validationErrorParam);
                                    this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                        console.log("has been logged out");
                                        this.$store.commit('SubmittedValuesStore/setErrorKey', 'generalValidationError');
                                        this.$router.push({ path: '/auto-login'});
                                    });
                                }
                            }

                            if (error.data.paramMedValidation.invalidModuleForParamMed != null) {
                                const invalidModuleForParamMed = error.data.paramMedValidation.invalidModuleForParamMed;
                                if (invalidModuleForParamMed === true) {
                                    const invalidModuleForParamMedErrorMessage = this.text('api.autologin.invalid.module');
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', invalidModuleForParamMedErrorMessage);
                                    this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                        this.$store.commit('SubmittedValuesStore/setErrorKey', 'invalidModuleForParamMed');
                                        this.$router.push({ path: '/auto-login'});
                                    });
                                }
                            }

                            if (error.data.paramMedValidation.invalidMappingToQuestionAnswerMap != null) {
                                const invalidParametersMap = error.data.paramMedValidation.invalidMappingToQuestionAnswerMap;
                                const invalidParametersArray = Object.keys(invalidParametersMap);
                                if (invalidParametersArray.length > 0) {
                                    let errorMessage = this.text('api.autologin.invalid.parameters');
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', errorMessage);
                                    forEach(invalidParametersArray, (parameter, index) => {
                                        const parameterMessage = (index + 1) + '. ' + parameter + ' : ' + invalidParametersMap[parameter];
                                        this.$store.commit('SubmittedValuesStore/setErrorMessages', parameterMessage);
                                    });

                                    this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                        this.$store.commit('SubmittedValuesStore/setErrorKey', 'invalidValueForParameters');
                                        this.$router.push({ path: '/auto-login'});
                                    });
                                }
                            }

                            if (error.data.paramMedValidation.invalidParamMedNameList != null && error.data.paramMedValidation.invalidParamMedNameList.length > 0) {
                                const invalidParamMedNameList = error.data.paramMedValidation.invalidParamMedNameList;
                                let errorMessage = this.text('api.autologin.invalid.parameter.name');

                                this.$store.commit('SubmittedValuesStore/setErrorMessages', errorMessage);
                                forEach(invalidParamMedNameList, (parameter, index) => {
                                    const parameterMessage = (index + 1) + '. ' + parameter;
                                    this.$store.commit('SubmittedValuesStore/setErrorMessages', parameterMessage);
                                });

                                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                                    this.$store.commit('SubmittedValuesStore/setErrorKey', 'invalidParamMedNameList');
                                    this.$router.push({ path: '/auto-login' });
                                });
                            }
                        }

                    });
            }
            else {
                this.$store.dispatch("AssessmentStartStore/loadAssessmentStartData");
            }

            window.addEventListener('keydown', this.handleKeyDowns);
            window.addEventListener('keyup', this.handleKeyUps);
            window.addEventListener('click', this.handleClicks);
        },

        destroyed() {
            window.removeEventListener('keydown', this.handleKeyDowns);
            window.removeEventListener('keyup', this.handleKeyUps);
            window.removeEventListener('click', this.handleClicks);
        },

        beforeMount() {
            let mustShowPatientPanel = sessionStorage.getItem('must-show-patient-panel');
            if (mustShowPatientPanel !== null) {
                this.mustShowPatientPanel = (mustShowPatientPanel == 'false') ? false : true;
            }
        },

        mounted() {

            this.vTextFieldPatientComment = null;

            if (this.mustShowPatientPanel !== false) {
                this.vTextFieldPatientComment = this.$refs["patientProfileRef"].$refs["vTextFieldPatientCommentRef"];
            }

            this.AS_PANEL_LIST = [];

            if (this.mustShowPatientPanel === false) {
                this.AS_PANEL_LIST = AS_PANELS_NO_PAT_PROFILE;
            }
            else {
                this.AS_PANEL_LIST = AS_PANELS;
            }

        },

        data() {
            return {
                mustShowPatientPanel: true,
                tempPatientComment: "",
                showComment: false,

                shortcutNav: {

                    isKeyboardNav: false,
                    isPanelHighlight: false,

                    crtPanel: AS_PANEL.START_QUESTIONS,

                    // Patient Info panel
                    crtPatientField: PATIENT_INFO_FIELD.FIELD_PID,
                    isFieldInEdit: false,

                    // StQ and GeQ panels
                    crtQuestion: null
                },

                isKeyDown: {}
            };
        },

        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                isAdmin: 'UserStore/getIsAdmin',
                isFooterNextBtnEnabled: 'AssessmentStartStore/getIsFooterNextBtnEnabled',
                selectedProductCode: 'ProductListStore/getSelectedProductCode',
                patientProfileStatus: 'AssessmentStartStore/getPatientProfileStatus',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                medicalStatuses: 'AssessmentAlertsStore/getMedicalStatuses',
                medicalStatus: 'AssessmentAlertsStore/getMedicalStatus',

                getStartQuestionsData: 'AssessmentStartStore/getStartQuestionsData',
                getGeneralQuestionsData: 'AssessmentStartStore/getGeneralQuestionsData',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                getSemiTarget: 'AssessmentAlertsStore/getSemiTarget',
                mustGeneralQuestionAreNotAllAnsweredPopup: 'AssessmentStartStore/getGeneralQuestionAreNotAllAnsweredPopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            }),

            mustShowCodes: {
                get () {
                    return this.$store.getters['UserStore/getDebugMustShowCodes'];
                },
                set (newVal) {
                    this.$store.commit('UserStore/setDebugMustShowCodes', newVal);
                },
            },

            isSemiTarget () {
                // I created a computed method to be useful if we will need to add a more complex condition
                // in order to visually mark the semiTarget attribute in the page (ex. buttons colors).
                return ((this.getSemiTarget === true) ? true : false);
            }
        },

        watch: {

            mustShowScoringPopup(newValue, oldValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            mustShowUrgentPopup(newValue, oldValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            showComment(newValue) {
                if (this.mustShowPatientPanel === false) {
                    this.navHandleDropdownsAfterClosingPopups(newValue);
                }
            }

        },


        methods: {

            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;

                // Place cursor at the end of the patient comment text
                let commentId = document.getElementById("comment");
                if (commentId != null) {

                    let commentLength = commentId.value.length;
                    commentId.selectionStart = commentLength;
                    commentId.selectionEnd = commentLength;
                }
            },

            isPatientCommentChanged() {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function() {
                if (this.isPatientCommentChanged()) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.showComment = false;
            },

            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            }),

            goToNextPage() {

                if (this.isFooterNextBtnEnabled || this.isSemiTarget) {
                    if (this.getGeneralQuestionsData.warningNotAnsweredMandatoryQuestion === true) {
                        this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', true);
                    }
                    else {
                        // Go to Choose Main Symptom page.
                        if (this.patientProfileStatus !== false) {
                            setTimeout( () => this.$router.push('/main-symptom'), 100);
                        }
                    }

                }
            },
            clearStoreAndLogout() {
                this.$store.commit("SubmittedValuesStore/resetStore");
                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                    this.$router.push('/');
                });
            },
            setLanguage() {
                const currentLang = this.selectedLang;
                if (currentLang !== this.assessmentLanguage) {
                    if (this.languageList.includes(this.assessmentLanguage)){
                        this.selectedLang = this.assessmentLanguage;
                        this.$store.commit("TranslationStore/setSelectedLanguage", this.assessmentLanguage);
                    }
                }
            },
            gotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: true
                });

                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            },


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/
            // helpers
            setIsKeyboardNav(value) {
              this.shortcutNav.isKeyboardNav = value;
            },

            // Handle Key/Mouse

            handleKeyDowns(event) {


                if (this.mustShowUrgentPopup === true || this.getMustShowVitalParamsForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Escape
                    case 27:
                        //If we're on PID or Patient Comment, exit editing
                        event.preventDefault();

                        if (this.mustShowPatientPanel === false && this.showComment === true) {
                            // If Patient Info Panel is not shown
                            this.savePatientComment();
                            this.showComment = false;
                        }

                        if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO && this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) {
                            this.navDeactivateTextField();
                        }

                        if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO && this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID) {
                            this.navDeactivatePID();
                        }

                        if (this.shortcutNav.isFieldInEdit === true) {
                            this.shortcutNav.isFieldInEdit = false;
                        }

                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // If the keyboard combination has been pressed while scoring popup is shown, then close scoring popup
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the keyboard combination has been pressed while GeneralQuestionAreNotAllAnswered popup is shown, then close the popup
                            if (this.mustGeneralQuestionAreNotAllAnsweredPopup === true) {
                                this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);

                                this.shortcutNav.isFieldInEdit = true;
                                this.shortcutNav.isPanelHighlight = false;
                            }

                            // If the keyboard combination has been pressed while MedicalDeviceInfo popup is shown, then close the popup
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);

                                this.shortcutNav.isFieldInEdit = true;
                                this.shortcutNav.isPanelHighlight = false;
                            }

                            if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO && this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID) {
                                this.navDeactivatePID();
                            }

                            if (this.mustShowPatientPanel === false) {

                                // If Patient Info Panel is not shown
                                this.showComment = true;

                                this.shortcutNav.isFieldInEdit = false;

                                if (this.vSelectCrtQuestion != null) {
                                    this.vSelectCrtQuestion.hideMenu();
                                }
                            }
                            else {
                                // Focus on textarea comment
                                this.navPatientCommentFocus();
                            }
                        }
                        break;

                    // P
                    case 80:
                        // ALT + P
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false ) {

                            if (this.medicalStatus === this.medicalStatuses.INFORMATION
                                || this.medicalStatus === this.medicalStatuses.URGENT) {

                                // for IE 11  - disable default behaviour
                                event.preventDefault();

                                if (this.mustGeneralQuestionAreNotAllAnsweredPopup === true) {
                                    this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);
                                }

                                if (this.mustShowInfoPopup === true) {
                                    this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                                }

                                if (this.shortcutNav.isFieldInEdit === true) {
                                    this.shortcutNav.isFieldInEdit = false;
                                }

                                if (this.vSelectCrtQuestion != null) {
                                    this.vSelectCrtQuestion.hideMenu();
                                }

                                this.showScoringPopup();
                            }
                        }
                        break;

                    // V
                    case 86:
                        // ALT + V
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // Prevent the default behavior
                            event.preventDefault();


                            // If the scoring popup is shown, then close it
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the info popup is shown, then close it
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }

                            // if the general question are not all answered popup is shown, then close it
                            if (this.mustGeneralQuestionAreNotAllAnsweredPopup === true) {
                                this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);
                            }

                            // If we have a field in edit, then exit editing
                            if (this.shortcutNav.isFieldInEdit === true) {
                                this.navDeactivateTextField();
                                this.navDeactivatePID();
                                this.shortcutNav.isFieldInEdit = false;
                            }
                            // If we have a select menu open then close and blur it.
                            if (this.vSelectCrtQuestion != null) {
                                this.vSelectCrtQuestion.hideMenu();
                                this.vSelectCrtQuestion.$el.blur();
                            }

                            // Open the dropdown menu for the vital parameters
                            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);

                            // Enable the keyboard navigation
                            this.shortcutNav.isKeyboardNav = true;
                        }

                        break;

                }

                // If Patient Profile Panel is not shown and patient comment popup is open, do nothing in the main page
                if (this.mustShowPatientPanel === false && this.showComment === true) {
                    return;
                }

                // If scoring popup is open, do nothing in the main page
                if (this.mustShowScoringPopup === true || this.mustGeneralQuestionAreNotAllAnsweredPopup === true || this.mustShowInfoPopup === true) {
                    return;
                }

                if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO
                    && (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID
                        || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT)
                    && this.shortcutNav.isFieldInEdit === true) {
                    return;
                }

                let isPanelNavigable = (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO && this.shortcutNav.isFieldInEdit === false) || this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS || this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS;

                switch (event.keyCode) {

                    // Backspace
                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // PageUp
                    case 33:
                        // PageUp
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["startAssessmentScrollingContentRef"].scrollTop -= 50;
                        }
                        break;

                    // PageDown
                    case 34:
                        // PageDown
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["startAssessmentScrollingContentRef"].scrollTop += 50;
                        }
                        break;

                    // ArrowUp
                    case 38:
                        if (isPanelNavigable) {
                            event.preventDefault();
                        }
                        break;

                    // ArrowDown
                    case 40:
                        if (isPanelNavigable) {
                            event.preventDefault();
                        }
                        break;

                }

                //Prevent repeated calls for certain keys
                if (this.isKeyDown[event.keyCode] === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = true;

                let isVSelectOpen = this.vSelectCrtQuestion != null && this.vSelectCrtQuestion.menuIsActive === true;

                switch (event.keyCode) {

                    // Shift
                    case 16:
                        // SHIFT
                        event.preventDefault();
                        if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO
                            && (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT)
                            && this.shortcutNav.isFieldInEdit === true) {
                            // Do nothing. Do not enable PanelHighlight
                        }
                        else {
                            this.navEnablePanelHighlight();
                        }
                        break;

                    // PageDown
                    case 34:
                        // SHIFT + PageDown
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            // Next (if enabled)
                            event.preventDefault();
                            this.goToNextPage();
                        }
                        break;

                    // End
                    case 35:
                        // SHIFT + End
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            event.preventDefault();

                            if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO &&
                                (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) &&
                                this.shortcutNav.isFieldInEdit === true) {
                                // We're editing a patient field. Do nothing but the default behaviour
                            }
                            else {
                                this.gotoScoringPage();
                            }
                        }
                        break;

                    // ArrowLeft
                    case 37:
                        // SHIFT + LEFT
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            if (isPanelNavigable) {
                                this.navFocusPrevPanel();
                            }
                        }
                        // SHIFT + CTRL + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {
                            if (isPanelNavigable) {
                                if (this.mustShowPatientPanel === false) {
                                    this.navSetShortcutNavCrtPanel(AS_PANEL.START_QUESTIONS, true);
                                }
                                else {
                                    this.navSetShortcutNavCrtPanel(AS_PANEL.PATIENT_INFO, true);
                                }
                            }
                        }
                        break;

                    // ArrowUp
                    case 38:
                        this.shortcutNav.isKeyboardNav = true;

                        // UP
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusPrevStGeQ(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusPrevStGeQ(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                                if (this.shortcutNav.isFieldInEdit !== true) {
                                    this.navFocusPrevPatientField();
                                }
                            }
                        }
                        // CTRL + UP
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusFirstStGeQ(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusFirstStGeQ(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                                if (this.shortcutNav.isFieldInEdit !== true) {
                                    this.navFocusPrevPatientField();
                                }
                            }
                        }
                        // SHIFT + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            if (isPanelNavigable) {
                                // Patient and StQ on First line, GeQ on second line
                                if (this.$vuetify.breakpoint.mdOnly) {

                                    if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO
                                        || this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {

                                        this.navSetShortcutNavCrtPanel(AS_PANEL.GENERAL_QUESTIONS, true);
                                    }
                                    else {
                                        this.navSetShortcutNavCrtPanel(AS_PANEL.START_QUESTIONS, true);
                                    }
                                }
                                else if (this.$vuetify.breakpoint.smAndDown) {
                                    // Each panel vertically
                                    this.navFocusPrevPanel();
                                }
                            }
                        }
                        // SHIFT + CTRL + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {
                            if (isPanelNavigable) {
                                // We have more than one line
                                if (this.$vuetify.breakpoint.mdOnly || this.$vuetify.breakpoint.smAndDown) {
                                    if (this.mustShowPatientPanel === false) {
                                        this.navSetShortcutNavCrtPanel(AS_PANEL.START_QUESTIONS, true);
                                    }
                                    else {
                                        this.navSetShortcutNavCrtPanel(AS_PANEL.PATIENT_INFO, true);
                                    }
                                }
                            }
                        }
                        break;

                    // ArrowRight
                    case 39:

                        // SHIFT + RIGHT
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            if (isPanelNavigable) {
                                this.navFocusNextPanel();
                            }
                        }
                        // SHIFT + CTRL + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {
                            if (isPanelNavigable) {
                                this.navSetShortcutNavCrtPanel(AS_PANEL.GENERAL_QUESTIONS, true);
                            }
                        }
                        break;

                    // ArrowDown
                    case 40:
                        this.shortcutNav.isKeyboardNav = true;

                        // DOWN
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusNextStGeQ(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusNextStGeQ(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                                if (this.shortcutNav.isFieldInEdit !== true) {
                                    this.navFocusNextPatientField();
                                }
                            }
                        }
                        // CTRL + DOWN
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusLastStGeQ(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {
                                if (isVSelectOpen === false) {
                                    this.navFocusLastStGeQ(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions);
                                }
                            }
                            else if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                                if (this.shortcutNav.isFieldInEdit !== true) {
                                    this.navFocusNextPatientField();
                                }
                            }
                        }
                        // SHIFT + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            if (isPanelNavigable) {
                                // Patient and StQ on First line, GeQ on second line
                                if (this.$vuetify.breakpoint.mdOnly) {

                                    if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO
                                        || this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {

                                        this.navSetShortcutNavCrtPanel(AS_PANEL.GENERAL_QUESTIONS, true);
                                    }
                                    else {
                                        this.navSetShortcutNavCrtPanel(AS_PANEL.START_QUESTIONS, true);
                                    }
                                }
                                else if (this.$vuetify.breakpoint.smAndDown) {
                                    // Each panel vertically
                                    this.navFocusNextPanel();
                                }
                            }
                        }
                        // SHIFT + CTRL + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {
                            if (isPanelNavigable) {
                                // We have more than one line
                                if (this.$vuetify.breakpoint.mdOnly || this.$vuetify.breakpoint.smAndDown) {
                                    this.navSetShortcutNavCrtPanel(AS_PANEL.GENERAL_QUESTIONS, true);
                                }
                            }
                        }
                        break;

                }
            },

            handleKeyUps(event) {

                this.isKeyDown[event.keyCode] = false;

                if (this.mustShowScoringPopup === true
                        || this.mustShowUrgentPopup === true
                        || this.mustGeneralQuestionAreNotAllAnsweredPopup === true
                        || this.getMustShowVitalParamsForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Enter
                    case 13:
                        // ENTER
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                                event.preventDefault();

                                if (this.shortcutNav.isKeyboardNav === false) {
                                    return;
                                }

                                if (this.shortcutNav.isFieldInEdit === false) {
                                    if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID) {
                                        this.navActivateFocusedPID();
                                    }
                                    else if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) {
                                        this.navActivateFocusedTextField();
                                    }
                                    this.shortcutNav.isFieldInEdit = true;
                                }
                            }
                        }
                        // CTRL + ENTER
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            if (this.mustShowPatientPanel === false && this.showComment === true) {
                                // If Patient Info Panel is not shown, close Patient comment popup
                                this.savePatientComment();
                                this.showComment = false;
                                this.setIsKeyboardNav(true);
                            }
                            // Handled on keyUps because keyDowns doesn't handle CTRL + ENTER
                            if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                                event.preventDefault();
                                if (this.shortcutNav.isFieldInEdit === true) {
                                    if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID) {
                                        this.navDeactivatePID();
                                    }
                                    else if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) {
                                        this.navDeactivateTextField();
                                    }
                                    this.shortcutNav.isFieldInEdit = false;
                                    this.setIsKeyboardNav(true);
                                }
                            }
                        }
                        break;

                    // Shift
                    case 16:
                        // SHIFT
                        if (this.showComment !== true) {
                            this.navDisablePanelHighlight();
                            this.navFocusPanelElement();
                        }
                        break;

                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                }

            },

            handleClicks(event) {

                if ((this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO
                        && (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID
                            || this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT))
                    || this.shortcutNav.crtPanel === AS_PANEL.VITAL_PARAMETERS
                    && this.shortcutNav.isFieldInEdit === true) {
                    // Do nothing. The user clicked on PID or patientComment so this.shortcutNav.isFieldInEdit must stay true
                }
                else {
                    this.shortcutNav.isFieldInEdit = false;
                }
                this.shortcutNav.isKeyboardNav = false;

            },

            // On Events

            onChangeAnswer(data) {

                if (this.shortcutNav.isKeyboardNav === false) {
                    return;
                }

                // If we get Urgent Popup, don't navigate to the next unanswered Question
                // Must set also the Focus on the Dropdown when return from Urgent Popup
                if (this.mustShowUrgentPopup === true) {
                    return;
                }

                if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {

                    let answeredStQIdx = this.getStartQuestionsData.questions.findIndex((currentQuestion) => {
                        return (currentQuestion.code === data.questionCode);
                    });

                    if (answeredStQIdx >= 0) {

                        //Find first Unanswered StQ (if exists)
                        let nextUnansweredStQIdx = this.getStartQuestionsData.questions.findIndex((currentQuestion, currentIndex) => {
                            return (currentIndex >  answeredStQIdx && currentQuestion.providedAnswer === null);
                        });

                        if (nextUnansweredStQIdx >= 0) {
                            this.navSelectQuestion(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions, nextUnansweredStQIdx, true);
                        }
                        else if (this.getGeneralQuestionsData.questions.length > 0) {

                            let firstUnansweredGeQIdx = this.getGeneralQuestionsData.questions.findIndex((currentQuestion) => {
                                if (currentQuestion.providedAnswer === null) {
                                    return true;
                                }
                            });

                            if (firstUnansweredGeQIdx >= 0) {
                                this.navSelectQuestion(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions, firstUnansweredGeQIdx, true);
                            }
                            else {

                                // Return to StQ and search if there are still not answered Q
                                let firstUnansweredStQIdx = this.getStartQuestionsData.questions.findIndex((currentQuestion) => {
                                    if (currentQuestion.providedAnswer === null) {
                                        return true;
                                    }
                                });

                                if (firstUnansweredStQIdx >= 0) {
                                    this.navSelectQuestion(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions, firstUnansweredStQIdx, true);
                                }
                                else {
                                    //Stay on the last answered
                                    this.navKeepVSelectElection();
                                }
                            }
                        }
                    }
                }
                else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {

                    let answeredGeQIdx = this.getGeneralQuestionsData.questions.findIndex((currentQuestion) => {
                        return (currentQuestion.code === data.questionCode);
                    });

                    if (answeredGeQIdx >= 0) {

                        //Find first Unanswered GeQ (if exists)
                        let nextUnansweredGeQIdx = this.getGeneralQuestionsData.questions.findIndex((currentQuestion, currentIndex) => {
                            return (currentIndex >  answeredGeQIdx && currentQuestion.providedAnswer === null);
                        });

                        if (nextUnansweredGeQIdx >= 0) {
                            this.navSelectQuestion(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions, nextUnansweredGeQIdx, true);
                        }
                        else {

                            let firstUnansweredStQIdx = this.getStartQuestionsData.questions.findIndex((currentQuestion) => {
                                if (currentQuestion.providedAnswer === null) {
                                    return true;
                                }
                            });

                            if (firstUnansweredStQIdx >= 0) {
                                this.navSelectQuestion(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions, firstUnansweredStQIdx, true);
                            }
                            else {

                                // Return to GeQ and search if there are still not answered Q
                                let firstUnansweredGeQIdx = this.getGeneralQuestionsData.questions.findIndex((currentQuestion) => {
                                    if (currentQuestion.providedAnswer === null) {
                                        return true;
                                    }
                                });

                                if (firstUnansweredGeQIdx >= 0) {
                                    this.navSelectQuestion(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions, firstUnansweredGeQIdx, true);
                                }
                                else {
                                    //Stay on the last answered
                                    this.navKeepVSelectElection();
                                }
                            }
                        }
                    }
                }
            },

            onQuestionClick(data) {

                if (data === null || data.crtPanel === null || data.questionCode === null) {
                    return;
                }

                if (data.crtPanel === AS_PANEL.START_QUESTIONS) {

                    let answeredQIdx = this.getStartQuestionsData.questions.findIndex((currentQuestion) => {
                        return (currentQuestion.code === data.questionCode);
                    });

                    if (answeredQIdx >= 0) {
                        this.navSelectQuestion(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions, answeredQIdx, false);
                    }
                }
                else if (data.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {

                    let answeredQIdx = this.getGeneralQuestionsData.questions.findIndex((currentQuestion) => {
                        return (currentQuestion.code === data.questionCode);
                    });

                    if (answeredQIdx >= 0) {
                        this.navSelectQuestion(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions, answeredQIdx, false);
                    }
                }
            },

            onPanelClick(crtPanelNew) {
                this.shortcutNav.crtPanel = crtPanelNew;
                this.navFocusPanelElement(false);
            },

            // Panel Highlight Enable/Disable

            navEnablePanelHighlight() {

                if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO && this.shortcutNav.isFieldInEdit === true) {
                    return;
                }

                this.shortcutNav.isPanelHighlight = true;
                this.shortcutNav.isKeyboardNav = true;
                this.shortcutNav.isFieldInEdit = false;

                //Wait for the completion of the answers animation
                setTimeout(() => {
                    if (this.vSelectCrtQuestion != null) {
                        this.vSelectCrtQuestion.hideMenu();
                    }
                },75);

                //left outside the timeout otherwise it will not scroll
                //if the shift button is released immediately after being pressed
                // this.navScrollIntoViewPanelOrSymptoms(); // @TODO ERROR undefined function: "Uncaught TypeError: this.navScrollIntoViewPanelOrSymptoms is not a function"
            },

            navDisablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = false;
            },

            navFocusPanelElement(isScrollIntoView) {

                if (typeof isScrollIntoView === 'undefined'){
                    isScrollIntoView = true; // Default value, if param is missing.
                }

                if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS || this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {

                    // There is the case when you select using Navigation a Question and after that, using mouse,
                    // you respond to other Question that makes disappears the crtQuestion. Bellow code identify this
                    let lostCrtQuestion = false;
                    if (this.shortcutNav.crtQuestion != null) {

                        let questionList = null;
                        if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {
                            questionList = this.getStartQuestionsData.questions;
                        }
                        else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {
                            questionList = this.getGeneralQuestionsData.questions;
                        }

                        if (questionList != null) {

                            let crtQuestionIdx = questionList.findIndex((currentQuestion) => {
                                return currentQuestion.code === this.shortcutNav.crtQuestion;
                            });

                            if (crtQuestionIdx < 0) {
                                lostCrtQuestion = true;
                            }
                        }
                    }

                    if (this.shortcutNav.crtQuestion === null || lostCrtQuestion === true) {

                        // Focus the first unanswered question in the new focused panel.
                        if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS) {
                            this.navFocusFirstPanelNeededQuestion(AS_PANEL.START_QUESTIONS, this.getStartQuestionsData.questions, isScrollIntoView);
                        }
                        else if (this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {
                            this.navFocusFirstPanelNeededQuestion(AS_PANEL.GENERAL_QUESTIONS, this.getGeneralQuestionsData.questions, isScrollIntoView);
                        }
                    }
                    else if (this.vSelectCrtQuestion != null) {

                        this.vSelectCrtQuestion.$el.focus();
                        if (isScrollIntoView !== false) {
                            this.navScrollIntoViewCrtQuestion();
                        }
                    }
                }
                else if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                    if (isScrollIntoView !== false) {
                        this.navScrollIntoViewCrtPatientField();
                    }
                }
            },

            navHandleDropdownsAfterClosingPopups(newValue) {
                if (newValue === false) {

                    if (this.shortcutNav.isKeyboardNav === false) {
                        return;
                    }

                    if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS || this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {

                        if (this.vSelectCrtQuestion != null
                            && this.vSelectCrtQuestion.$el != null) {

                            this.vSelectCrtQuestion.$el.focus();
                        }
                    }
                    else if (this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                        // we're on PATIENT_INFO_PANEL
                        if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID
                            && this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'] !== null
                            && this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$el !== null) {
                            this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$el.focus();
                        }
                        else if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT
                            && this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'] !== null
                            && this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$el !== null) {
                            this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$el.focus();
                        }
                    }
                }
            },

            // Change current panel

            navSetShortcutNavCrtPanel(crtPanelNew, isScrollIntoView) {

                let crtPanelOld = this.shortcutNav.crtPanel;
                this.shortcutNav.crtPanel = crtPanelNew;

                if (isScrollIntoView === true) {
                    this.navScrollIntoViewCrtPanel();
                }

                // We make actions only if the actual panel changed
                if (crtPanelOld !== crtPanelNew) {

                    if (crtPanelOld === AS_PANEL.START_QUESTIONS
                        || crtPanelOld === AS_PANEL.GENERAL_QUESTIONS) {

                        // We lost a panel with possible vSelect focused. Loose that focus
                        if (this.vSelectCrtQuestion != null) {

                            this.vSelectCrtQuestion.hideMenu();
                            this.vSelectCrtQuestion.$el.blur();
                        }
                    }
                }
            },

            // Scroll Into View

            navScrollIntoViewCrtPanel() {

                let currentPanelContainer = null;

                if (this.mustShowPatientPanel !== false && this.shortcutNav.crtPanel === AS_PANEL.PATIENT_INFO) {
                    currentPanelContainer = this.$refs['patientProfileRef'].$el;
                }
                else if (this.shortcutNav.crtPanel === AS_PANEL.START_QUESTIONS
                         || this.shortcutNav.crtPanel === AS_PANEL.GENERAL_QUESTIONS) {

                    currentPanelContainer = this.$refs['questionsPanel_' + this.shortcutNav.crtPanel].$el;
                }

                if (currentPanelContainer != null) {

                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = currentPanelContainer.offsetTop - 10;
                }

            },

            navScrollIntoViewCrtPatientField() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                let containerScrollable = document.querySelector('.scrolling-content');

                if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_PID) {
                    containerScrollable.scrollTop = this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$el.offsetTop - 120;
                }
                else if (this.shortcutNav.crtPatientField === PATIENT_INFO_FIELD.FIELD_COMMENT) {
                    containerScrollable.scrollTop = this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$el.offsetTop - 120;
                }
            },

            navScrollIntoViewCrtQuestion() {

                if (this.vSelectCrtQuestion != null) {
                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = this.vSelectCrtQuestion.$el.offsetTop - 120;
                }
            },

            // Panels navigation

            navFocusNextPanel() {

                let crtPanelIdx = this.AS_PANEL_LIST.indexOf(this.shortcutNav.crtPanel);

                if (this.AS_PANEL_LIST.length === (crtPanelIdx + 1)) {
                    // Focus the first panel.
                    this.navSetShortcutNavCrtPanel(this.AS_PANEL_LIST[0], true);
                }
                else {
                    // Focus the next panel.
                    this.navSetShortcutNavCrtPanel(this.AS_PANEL_LIST[crtPanelIdx + 1], true);
                }
            },

            navFocusPrevPanel() {

                let crtPanelIdx = this.AS_PANEL_LIST.indexOf(this.shortcutNav.crtPanel);

                if (crtPanelIdx === 0) {
                    // Focus the last panel.
                    this.navSetShortcutNavCrtPanel(this.AS_PANEL_LIST[this.AS_PANEL_LIST.length - 1], true);
                }
                else {
                    // Focus the previous panel.
                    this.navSetShortcutNavCrtPanel(this.AS_PANEL_LIST[crtPanelIdx - 1], true);
                }
            },

            navFocusNextStGeQ(questionPanel, questionList) {

                let currentIdx = -1;

                if (this.shortcutNav.crtQuestion !== null) {

                    currentIdx = questionList.findIndex((currentQuestion) => {
                        if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                            return true;
                        }
                    });

                }

                if (currentIdx >= 0) {

                    // We found a selected question. Move the selection to the nextUnanswered Question

                    if (questionList.length === (currentIdx + 1)) {
                        this.navSelectQuestion(questionPanel, questionList, 0, true);
                    }
                    else {
                        this.navSelectQuestion(questionPanel, questionList, currentIdx + 1, true);
                    }
                }
                else if (questionList.length > 0) {
                    this.navSelectQuestion(questionPanel, questionList, 0, true);
                }

            },

            navFocusPrevStGeQ(questionPanel, questionList) {

                let currentIdx = -1;

                if (this.shortcutNav.crtQuestion !== null) {

                    currentIdx = questionList.findIndex((currentQuestion) => {
                        if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                            return true;
                        }
                    });

                }

                if (currentIdx >= 0) {

                    // We found a selected question. Move the selection to the nextUnanswered Question

                    if (currentIdx === 0) {

                        this.navSelectQuestion(questionPanel, questionList, questionList.length - 1, true);
                    }
                    else {
                        this.navSelectQuestion(questionPanel, questionList, currentIdx - 1, true);
                    }
                }
                else if (questionList.length > 0) {
                    this.navSelectQuestion(questionPanel, questionList, 0, true);
                }
            },

            navFocusFirstStGeQ(questionPanel, questionList) {

                if (questionList.length > 0) {
                    this.navSelectQuestion(questionPanel, questionList, 0, true);
                }
            },

            navFocusLastStGeQ(questionPanel, questionList) {

                if (questionList.length > 0) {
                    this.navSelectQuestion(questionPanel, questionList, questionList.length - 1, true);
                }
            },

            navFocusFirstPanelNeededQuestion(questionPanel, questionList, isScrollIntoView) {
                if (typeof isScrollIntoView === 'undefined'){
                    isScrollIntoView = true; // Default value, if param is missing.
                }

                if (typeof questionList !== "undefined") {

                    let nextUnansweredQuestionIdx = questionList.findIndex((currentQuestion) => {
                        if (currentQuestion.providedAnswer === null) {
                            return true;
                        }
                    });

                    if (nextUnansweredQuestionIdx !== -1) {

                        this.navSelectQuestion(questionPanel, questionList, nextUnansweredQuestionIdx, isScrollIntoView);
                    }
                    else if (questionList.length > 0) {

                        this.navSelectQuestion(questionPanel, questionList, 0, isScrollIntoView);
                    }
                }
            },

            navSelectQuestion(questionPanel, questionList, selectQuestionIdx, isScrollIntoView) {

                this.navSetShortcutNavCrtPanel(questionPanel, isScrollIntoView);

                if (questionList.length === 0) {
                    return;
                }

                let isNewQuestion = false;

                let newCrtQuestion = questionList[selectQuestionIdx].code;
                if (newCrtQuestion !== this.shortcutNav.crtQuestion) {
                    isNewQuestion = true;
                }

                this.shortcutNav.crtQuestion = newCrtQuestion;

                if (this.$refs['questionsPanel_' + questionPanel] != null
                    && this.$refs['questionsPanel_' + questionPanel].$refs['questionListBlockRef'] != null
                    && this.$refs['questionsPanel_' + questionPanel].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion] != null
                    && this.$refs['questionsPanel_' + questionPanel].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0] != null
                    && this.$refs['questionsPanel_' + questionPanel].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0].$refs['question-dropdown-' + this.shortcutNav.crtQuestion] != null) {

                    if (this.vSelectCrtQuestion != null && isNewQuestion === true) {
                        // Close the other Question that lose focus
                        this.vSelectCrtQuestion.hideMenu();
                        this.vSelectCrtQuestion.$el.blur();
                    }

                    this.vSelectCrtQuestion = this.$refs['questionsPanel_' + questionPanel].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0].$refs['question-dropdown-' + this.shortcutNav.crtQuestion];
                    this.vSelectCrtQuestion.$el.focus();

                    if (isScrollIntoView === true) {
                        this.navScrollIntoViewCrtQuestion();
                    }
                }
            },

            navFocusNextPatientField() {

                let crtFieldIdx = PATIENT_FIELD_LIST.indexOf(this.shortcutNav.crtPatientField);

                if (PATIENT_FIELD_LIST.length === (crtFieldIdx + 1)) {
                    // Focus the first field
                    this.shortcutNav.crtPatientField = PATIENT_FIELD_LIST[0];
                }
                else {
                    // Focus the next field
                    this.shortcutNav.crtPatientField = PATIENT_FIELD_LIST[crtFieldIdx + 1];
                }
                this.navScrollIntoViewCrtPatientField();
            },

            navFocusPrevPatientField() {

                let crtFieldIdx = PATIENT_FIELD_LIST.indexOf(this.shortcutNav.crtPatientField);

                if (crtFieldIdx === 0) {
                    // Focus the last panel.
                    this.shortcutNav.crtPatientField = PATIENT_FIELD_LIST[PATIENT_FIELD_LIST.length - 1];
                }
                else {
                    // Focus the previous panel.
                    this.shortcutNav.crtPatientField = PATIENT_FIELD_LIST[crtFieldIdx - 1];
                }
                this.navScrollIntoViewCrtPatientField();
            },

            navKeepVSelectElection() {

                // For Enter (13) let Vuetify to open it and We select the Selected entry or put on the first position
                if (this.vSelectCrtQuestion != null && this.vSelectCrtQuestion.menuIsActive) {

                    if (this.vSelectCrtQuestion.$refs != null
                        && this.vSelectCrtQuestion.$refs.menu != null
                        && this.vSelectCrtQuestion.$refs.menu.$children != null
                        && this.vSelectCrtQuestion.$refs.menu.$children[0] != null
                        && this.vSelectCrtQuestion.$refs.menu.$children[0].$children != null
                        && this.vSelectCrtQuestion.$refs.menu.$children[0].$children[0] != null
                        && this.vSelectCrtQuestion.$refs.menu.$children[0].$children[0].$children != null) {

                        let entryList = this.vSelectCrtQuestion.$refs.menu.$children[0].$children[0].$children;

                        let activeEntryIdx = entryList.findIndex((entry) => {
                            return entry.isActive;
                        });

                        if (activeEntryIdx < 0) {
                            activeEntryIdx = 0;
                        }

                        this.vSelectCrtQuestion.$refs.menu.listIndex = activeEntryIdx;
                    }
                }

            },

            navPatientCommentFocus() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                this.navSetShortcutNavCrtPanel(AS_PANEL.PATIENT_INFO, true);
                this.shortcutNav.crtPatientField = PATIENT_INFO_FIELD.FIELD_COMMENT;
                this.shortcutNav.isFieldInEdit = true;
                this.shortcutNav.isKeyboardNav = true;
                this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$refs.input.focus();
            },

            /**
             * Activate currently focused field.
             */
            navActivateFocusedTextField() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                if (this.shortcutNav.crtPatientField === null) {
                    return;
                }
                else {
                    this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$refs.input.focus();
                }

            },

            navDeactivateTextField() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                if (this.shortcutNav.crtPatientField === null) {
                    return;
                }
                else {
                    this.$refs['patientProfileRef'].$refs['vTextFieldPatientCommentRef'].$refs.input.blur();
                }
            },

            /**
             * Activate currently focused PID.
             */
            navActivateFocusedPID() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                if (this.shortcutNav.crtPatientField === null) {
                    return;
                }
                else {
                    this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$refs.input.focus();
                }

            },

            navDeactivatePID() {

                // Return when Patient Panel is not shown
                if (this.mustShowPatientPanel === false) {
                    return;
                }

                if (this.shortcutNav.crtPatientField === null) {
                    return;
                }
                else {
                    this.$refs['patientProfileRef'].$refs['vTextFieldPidRef'].$refs.input.blur();
                }
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        },

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .container.grid-list-xl {

        .layout.general-info {
            margin-bottom: -95px;
        }

    }

    /*.assessment-start-container .topbar-patient-info-content {*/
    /*    position: fixed;*/
    /*    right: 175px !important;*/
    /*}*/


    @media only screen and (max-width: 900px) {

        .topbar-patient-info-content {
           // right: 100px !important;
        }
    }

    /*.noComment .assessment-alerts {*/
    /*    right: 12px;*/
    /*}*/


    @media only screen and (max-width: 960px) {
        .assessment-start-container, .main-symptom-container, .container-symptoms-questions {
            .noComment {
                /*.topbar-patient-info-content {*/
                /*    position: fixed;*/
                /*    left: 45px !important;*/
                /*    margin-top: 12px;*/
                /*    font-size: 13px;*/
                /*}*/
            }

        }

        /*.noComment .assessment-alerts {*/
        /*    right: 2px;*/
        /*}*/
    }

    /*@media only screen and (min-width: 961px) {*/
    /*    .assessment-start-container, .main-symptom-container, .container-symptoms-questions {*/
    /*        .noComment {*/
    /*            .topbar-patient-info-content {*/
    /*                position: fixed;*/
    /*                left: 45px !important;*/
    /*                margin-top: 12px;*/
    /*                font-size: 13px;*/
    /*            }*/
    /*        }*/

    /*    }*/

    /*}*/
</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-start/AssessmentStartPage.vue